module.exports = __webpack_public_path__ + "img/7.cb7142e2.png";